import React from "react";
import styled from "styled-components";
import PriceTable, { priceList } from "./PriceTable";
export const closeButton = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="2.057"
      height="20.57"
      transform="matrix(0.707099 -0.707115 0.707099 0.707115 0.0849609 1.88086)"
      fill="#A5BFD7"
    />
    <rect
      width="2.057"
      height="20.57"
      transform="matrix(0.707099 0.707115 -0.707099 0.707115 14.6299 0.425781)"
      fill="#A5BFD7"
    />
  </svg>
);
export default function PriceModal({ onClose }) {
  return (
    <SPriceModal>
      <div className="modal-title">QUY ĐỔI ĐIỂM BÌNH CHỌN</div>
      <div
        className="close-btn"
        onClick={() => {
          onClose && onClose();
        }}
      >
        {closeButton}
      </div>
      <div className="content">
        <p>
          Số lượng bình chọn của khán giả sẽ được tính bằng Sao Cống hiến theo
          quy đổi như sau:
        </p>
        <table>
          <thead>
            <tr>
              <th>Số lượng sao</th>
              <th>Số điểm tương ứng</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>2.000 ⭐️</td>
              <td>1 điểm</td>
            </tr>
            <tr>
              <td>200.000 ⭐️</td>
              <td>100 điểm</td>
            </tr>
          </tbody>
        </table>
        <p className="convert-title">Bảng quy đổi điểm Sao Cống hiến</p>
        <table>
          <thead>
            <tr>
              <th>Điểm bình chọn</th>
              <th>Phí bình chọn/lượt/tài khoản (VNĐ)</th>
            </tr>
          </thead>
          <tbody>
            {priceList.map((p, ind) => {
              return (
                <tr key={ind + 100}>
                  <td>{p.combo}</td>
                  <td>{p.price}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </SPriceModal>
  );
}

const SPriceModal = styled.div`
  background: #212635;
  border-radius: 12px;
  width: 555px;
  position: relative;

  .modal-title {
    font-size: 20px;
    font-weight: 700;
    padding: 12px 25px;
    border-bottom: 1px solid #2a3045;
  }

  .close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }

  .content {
    padding: 32px 25px;

    p {
      text-align: center;
      margin: 0 0 16px;
    }

    .convert-title {
      margin: 40px 0 16px;
    }
  }

  table {
    border-collapse: separate;
    border-spacing: 8px;
    margin: 0 auto;

    th {
      padding: 8px 20px;
      border-radius: 8px;
      background: linear-gradient(
        94.08deg,
        rgba(161, 91, 255, 0.3) 0%,
        rgba(255, 138, 90, 0.3) 100%
      );
      font-weight: 600;
      text-align: center;
    }

    td {
      padding: 8px 20px;
      border-radius: 8px;
      background: #2a3045;
      text-align: center;
    }
  }

  @media only screen and (max-width: 767px) {
    .content {
      padding: 32px 15px;
    }
  }
`;
